import Swiper from 'swiper';
import {FreeMode} from 'swiper/modules';

new Swiper('.catalog-detail__reviews', {
    modules: [FreeMode],
    direction: 'vertical',
    slidesOffsetAfter: 60,
    spaceBetween: 10,
    slidesPerView: 2,
    freeMode: true,
    breakpoints: {
        600: {
            direction: 'horizontal',
        },
    },
});
